
let organize = function(){
	//console.log('organize animation');
};

export {organize};